// extracted by mini-css-extract-plugin
export default {"image":"p0-z","loaded":"q0-z"};